import MasterService from "./MasterService";

export const CommonService = {
    ...MasterService,

    getMasterConfig() {
        return this.post('/common/master/config')
    },

    getPartnerList() {
        return this.post('/common/partner-list')
    },

    getBankList() {
        return this.get('/common/bankList')
    },

    addDocument(params: object) {
        return this.post('/common/uploadDoc',params)
    },
    uploadSoaCsv(params: object) {
        return this.post('/bulkUpload/uploadSoaCsv', params)
    },
    getBulkUploadCsvLogs(){
        return this.post('/bulkUpload/history', {})
    },
    getSampleFile(){
        return this.post('/bulkUpload/sampleFile')
    },
    downloadSoa(params: object){
        return this.post('/bulkUpload/download/Soa',params)
    },

    getAgencyList() {
        return this.get('/common/agencyList')
    },
    getPaymentMethodData(){
        return this.post('/lead/getLeadPaymentMethod')
    },
    deleteDocProof(params: object){
        return this.post('/lead/deletePaymentProof',params)
    }
}